// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3357":"99c1d61d","5439":"c243f15e"}[chunkId] + ".chunk.css";
};